// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/resources/" + chunkId + "." + {"90":"250307f5","524":"bd606397"}[chunkId] + ".js";
};